import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import images from '_images';
import moment from 'moment';
import HOC from '_HOC';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Header = styled.h2`
    font-size: 24px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    margin-bottom: 15px;
`;

const Description = styled.h4`
    color: #747474;
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    margin-top: 5px;
    margin-bottom: 25px;
`;

const CollectionIconHolder = styled.div`
  flex: 1;
  max-width: 35px !important;
  height: 35px !important;
  border-radius: 50% !important;
  padding: 7px !important;
  box-sizing: border-box;
`;

const CollectionIcon = styled.img`
  width: 100% !important;
  height: 100% !important;
`;

const Button = styled.button`
    gap: 10px;
    width: 100%;
    height: auto;
    border: none;
    display: flex;
    padding: 15px;
    cursor: pointer;
    min-height: 50px;
    margin-bottom: 5px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #dbdbdb;
    padding-left: 0 !important;
    align-items: center;
`;

const TitleContainer = styled.div`
    flex: 1;
`;

const Title = styled.p`
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-align: left;
    font-family: Roboto, sans-serif;
`;

const ArrowContainer = styled.div`
    flex: 1;
    max-width: 16px;
    padding-top: 5px;
`;

const Arrow = styled.img``;

const MissedCollections = ({ config, props }) => {
  const { history } = props;
  const { collection, schedule } = config;

  const [eventObject, setEventObject] = useState({});

  const currentDay = moment().format('D');
  const currentYear = moment().format('YYYY');
  const currentMonth = moment().format('MMMM');
  const currentMonthNumber = moment().format('M');
  const currentExactTime = moment().format('HH:mm:ss');
  const currentMomentTime = moment(currentExactTime, 'HH:mm:ss');

  useEffect(() => {
    if (
      schedule
      && schedule.length
    ) {
      const tempWholeMonthObject = {
        month: currentMonth,
        monthEvent: {},
      };
      const currentYearObject = schedule.find(({ year }) => year === Number(currentYear));

      if (
        currentYearObject
        && currentYearObject.months
        && currentYearObject.months[currentMonthNumber - 1]
      ) {
        currentYearObject.months[currentMonthNumber - 1].events.map(({ day, collections }) => {
          tempWholeMonthObject.monthEvent[day] = collections;
          return undefined;
        });
        setEventObject(tempWholeMonthObject);
      }
    }
  }, [schedule, currentYear]);

  const collectionClickHandler = ({ title, curbTime }, collId) => {
    const curbTimeMoment = moment(curbTime, 'HH:mm:ss');
    const passedTime = currentMomentTime.isAfter(curbTimeMoment);
    const yesterDay = eventObject.monthEvent[currentDay - 1];
    const isYesterDay = (yesterDay)
      ? !!yesterDay.find(({ id }) => id === Number(collId.replace(/collection-/, '')))
      : false;

    const todayCollectionExistence = (eventObject && Object.keys(eventObject).length
      && eventObject.monthEvent[currentDay])
      ? !!eventObject.monthEvent[currentDay].find(({ id: collectionId }) => collectionId === Number(collId.replace(/collection-/, '')))
      : false;

    const yesterdayCollectionExistence = (eventObject && Object.keys(eventObject).length && yesterDay) ? !!yesterDay.find(({ id: collectionId }) => collectionId === Number(collId.replace(/collection-/, ''))) : false;

    if (
      eventObject
      && Object.keys(eventObject).length
      && eventObject.month
      && eventObject.month === currentMonth
      && !todayCollectionExistence
      && !yesterdayCollectionExistence
    ) {
      history.push('/help/not-scheduled-for-today', { collId, title });
      return;
    }

    if (
      eventObject
      && !Object.keys(eventObject).length
    ) {
      history.push('/help/not-scheduled-for-today', { collId, title });
      return;
    }

    // -----------------------------------------------------------------------

    // time_check
    if (
      eventObject
      && Object.keys(eventObject).length
      && eventObject.month
      && eventObject.month === currentMonth
      && !todayCollectionExistence
      && yesterdayCollectionExistence
    ) {
      history.push('/help/time-check', {
        title, isYesterday: isYesterDay, curbTime
      });
      return;
    }

    if (
      eventObject
      && Object.keys(eventObject).length
      && eventObject.month
      && eventObject.month === currentMonth
      && todayCollectionExistence
      && passedTime
    ) {
      history.push('/help/time-check', {
        title, isYesterday: isYesterDay, curbTime
      });
      return;
    }

    // -----------------------------------------------------------------------

    // please_wait
    if (
      eventObject
      && Object.keys(eventObject).length
      && eventObject.month
      && eventObject.month === currentMonth
      && todayCollectionExistence
      && !passedTime
    ) {
      history.push('/help/description-page', {
        title: '',
        description: _('help.please_wait_until_curbTime', { type: curbTime })
      });
    }
  };

  return (
    <Container>
      <Header>{_('help.which_collection_was_missed')}</Header>
      <Description>{_('help.please_select_any_collection_that_you_want')}</Description>

      <ul style={{ padding: 0 }}>
        {
          Object.keys(collection)
            .filter((item) => ((collection[item].details.path) ? collection[item].details.path.includes('collection') : null))
            .map((coll) => (
              <li style={{ listStyle: 'none' }}>
                <Button
                  key={coll}
                  onClick={() => collectionClickHandler(collection[coll], coll)}
                >
                  <CollectionIconHolder style={{ backgroundColor: (collection[coll].colour) ? `#${collection[coll].colour}` : '#000000' }}>
                    <CollectionIcon
                      alt
                      src={`${images.calendar.iconicShape}${collection[coll].iconicShape.replace('_', '-')}.png`}
                    />
                  </CollectionIconHolder>

                  <TitleContainer>
                    <Title>{collection[coll].title}</Title>
                  </TitleContainer>

                  <ArrowContainer>
                    <Arrow
                      src={images.calendar.rightArrow}
                      alt
                    />
                  </ArrowContainer>
                </Button>
              </li>
            ))
        }
      </ul>

    </Container>
  );
};

export default HOC(MissedCollections);
